import React from "react";
import { skeletonGridClasses } from "../styles/componentClasses";

export function SkeletonGrid() {
  return (
    <div className={skeletonGridClasses.wrapper}>
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className={skeletonGridClasses.card}
        >
          <div className={skeletonGridClasses.media} />
          <div className={skeletonGridClasses.lineLg} />
          <div className={skeletonGridClasses.lineSm} />
          <div className={skeletonGridClasses.lineMd} />
          <div className={skeletonGridClasses.lineShort} />
          <div className={skeletonGridClasses.button} />
        </div>
      ))}
    </div>
  );
}
